module.exports = __webpack_public_path__ + "6bdf849675b04350270d74fca9bf8baf.woff";